export const isLegacyProductDataStructure = product => typeof product?.variants === 'undefined';

const isValidDataFormat = (product) => {
    const hasVariants = product?.variants?.length > 0;
    const productName = product?.product_name;

    return hasVariants && productName && product.variants[0].media !== undefined;
};

export const hasInvalidDataFormat = (products) => {
    if (!products?.length) { return false; }

    const productsToCheck = products.length > 1 ? [products[0], products[products.length - 1]] : [products[0]];

    return productsToCheck.some(product => !isValidDataFormat(product));
};
